export const baseURL = "https://apiloyalty.novusloyalty.com/web/api/"